import { render, staticRenderFns } from "./Tab8.vue?vue&type=template&id=fb332124&scoped=true"
import script from "./Tab8.vue?vue&type=script&lang=js"
export * from "./Tab8.vue?vue&type=script&lang=js"
import style0 from "./Tab8.vue?vue&type=style&index=0&id=fb332124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb332124",
  null
  
)

export default component.exports